/* eslint-disable vue/component-name-in-template-casing */
import Vue from "vue";
export const EventBus = new Vue();
